import React from 'react'
import landPackageIcon from '../../assets/icons/land-package-icon.svg'

export const EQuotePackageOutlineLandProgram = props => {
  const { landProgram, programTitle } = props
  return (
    <div className="equote-preview-package-outline--land-program">
      <div className="equote-preview-package-outline--land-program-flag">
        <div className="equote-preview-package-outline--land-program-flag--img-container">
          <img src={landPackageIcon} alt="Cruise Land Package" />
        </div>
        <p className="u-remove-margin">{`${programTitle}-Cruise Land Program`}</p>
      </div>
      <div className="equote-preview-package-outline--land-program-title">
        <p className="u-remove-margin">{landProgram.title}</p>
      </div>
    </div>
  )
}

export default EQuotePackageOutlineLandProgram
